var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._g({attrs:{"src":_vm.computedSrc,"alt":_vm.alt}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }